<template>
	<v-dialog
		v-model="active"
		max-width="320"
	>
		<v-card>
			<v-card-title>
				<v-icon
					color="error"
					start
					icon="$alert"
				/>
				<slot name="title">
					<translate>
						Attention!
					</translate>
				</slot>
			</v-card-title>
			<v-card-text>
				<slot />
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn
					color="error"
					variant="text"
					@click="active = false"
				>
					Ok
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'WarningPopup',
	props: {
		enabled: {
			type: Boolean,
			required: false,
			default: true
		}
	},
	data () {
		return {
			active: this.enabled,
		};
	}
};
</script>
